// File: components/BaseConfiguration.js
import React, { useState } from 'react';
import LocationMultiplier from './LocationMultiplier';
import useLocalization from '../hooks/useLocalization';

const BaseConfiguration = ({
  baseSuccessRate,
  setBaseSuccessRate,
  location,
  setLocation,
  baseConfigInfo, // Can still accept this prop but will use localization if not provided
  locationMultiplier,
  setLocationMultiplier,
  locationMultiplierInfo // Can still accept this prop but will use localization if not provided
}) => {
  const translations = useLocalization();
  const [showLocationInfo, setShowLocationInfo] = useState(false);

  // Use the provided props or fall back to translations
  const config = baseConfigInfo || translations.baseConfig;
  const multiplierInfo = locationMultiplierInfo || translations.locationMultiplier;

  return (
    <div>
      {/* Base success rate */}
      <div className="mb-6">
        <h2 className="text-xl font-semibold mb-2">{config.baselineSuccessPercent}</h2>
        <div className="mb-2">
          <input
            type="number"
            value={baseSuccessRate}
            onChange={(e) => setBaseSuccessRate(Number(e.target.value))}
            className="w-full p-2 border rounded"
            min="0"
            max="100"
          />
        </div>
        <p className="text-sm text-gray-600">
          {config.baseSuccessRateDescription}
        </p>
      </div>

      {/* Location */}
      <div className="mb-6">
        <h2 className="text-xl font-semibold mb-2 flex items-center">
          {config.locationTitle}
          <button
            className="ml-2 text-blue-500 text-sm"
            onClick={() => setShowLocationInfo(!showLocationInfo)}
          >
            {showLocationInfo ? config.hideInfoLabel : config.moreInfoLabel}
          </button>
        </h2>

        {showLocationInfo && config.locationInfo}

        <div className="flex flex-col gap-2 mb-4">
          <label className="flex items-center">
            <input
              type="radio"
              name="location"
              checked={location === 'stcharles'}
              onChange={() => setLocation('stcharles')}
              className="mr-2"
            />
            {config.locationOptions.stcharles.name}
          </label>
          <label className="flex items-center">
            <input
              type="radio"
              name="location"
              checked={location === 'sanfrancisco'}
              onChange={() => setLocation('sanfrancisco')}
              className="mr-2"
            />
            {config.locationOptions.sanfrancisco.name}
          </label>
        </div>

        {/* Location Multiplier */}
        <LocationMultiplier
          locationMultiplier={locationMultiplier}
          setLocationMultiplier={setLocationMultiplier}
          isVisible={location === 'sanfrancisco'}
          locationMultiplierInfo={multiplierInfo}
        />
      </div>
    </div>
  );
};

export default BaseConfiguration;